module.exports = __webpack_public_path__ + "img/photo.de236641.svg";